export default function ProfitCalculation() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ② 利益計算の自動化
          </div>
          <p className="text-2xl font-bold text-gray-900 mt-4">
            Amazonはここが地獄。
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold mb-6">利益式（実務用）</h3>
            <div className="space-y-4 text-lg">
              <div className="font-bold text-xl mb-4">利益 =</div>
              <div className="pl-6 space-y-3">
                <div className="flex items-center gap-3">
                  <i className="ri-add-line"></i>
                  <span>販売価格</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-subtract-line"></i>
                  <span>仕入れ</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-subtract-line"></i>
                  <span>FBA手数料</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-subtract-line"></i>
                  <span>送料</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-subtract-line"></i>
                  <span>Amazon販売手数料</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-subtract-line"></i>
                  <span>消費税</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col justify-center space-y-8">
            <div className="bg-primary/5 border-2 border-primary rounded-2xl p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-code-s-slash-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-xl mb-2">GASで自動計算</h4>
                  <p className="text-gray-700">
                    Google Apps Scriptを使用して、すべての計算を自動化
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-white border-2 border-primary rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <i className="ri-arrow-right-line text-3xl text-primary"></i>
                <p className="text-xl font-bold text-gray-900">
                  すべてのASINで<br />
                  「本当の利益」が即出る。
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded-xl p-6 text-center">
                <div className="text-3xl font-black text-primary mb-2">100%</div>
                <div className="text-sm text-gray-600">計算精度</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6 text-center">
                <div className="text-3xl font-black text-primary mb-2">0秒</div>
                <div className="text-sm text-gray-600">計算時間</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
